'use client'

import { useEffect, useState } from 'react'

import Image from 'next/image'

import styles from './Countdown.module.scss'

import { calculateTimeLeft } from '@/utils/calculateTimeLeft'

type CountdownProps = {
  countdown?: number
  onCountdownEnd?: () => void
}

export default function Countdown({ countdown, onCountdownEnd }: CountdownProps) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(countdown))

  useEffect(() => {
    if (!countdown) return

    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft(countdown))
    }, 1000)

    return () => clearInterval(interval)
  }, [countdown])

  useEffect(() => {
    if (
      !timeLeft.days &&
      !timeLeft.hours &&
      !timeLeft.minutes &&
      !timeLeft.seconds &&
      onCountdownEnd
    ) {
      onCountdownEnd()
    }
  }, [timeLeft, onCountdownEnd])

  return (
    <div className={styles.countdown}>
      <div className={styles.countdown__item}>
        <Image alt="Rewards In" height={24} src="/assets/img/clock.svg" width={24} />
        Rewards In:
      </div>
      <div className={styles.countdown__item}>
        {timeLeft.days || '0'} {timeLeft.days === 1 ? 'Day' : 'Days'}
      </div>
      <div className={styles.countdown__item}>
        {timeLeft.hours || '0'} {timeLeft.hours === 1 ? 'Hour' : 'Hours'}
      </div>
      <div className={styles.countdown__item}>
        {timeLeft.minutes || '0'} {timeLeft.minutes === 1 ? 'Min' : 'Mins'}
      </div>
      <div className={styles.countdown__item}>
        {timeLeft.seconds || '0'} {timeLeft.seconds === 1 ? 'Sec' : 'Secs'}
      </div>
    </div>
  )
}
